import React, { useState } from 'react';
import { ComposedChart, Line, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, ReferenceLine } from 'recharts';
import { statusColor } from './StatusBadge';

export const CLASS_COLORS = { A: '#34d399', B: '#38bdf8', C: '#fbbf24' };
const TT = { contentStyle: { background: '#16181d', border: '1px solid #2a2d33', borderRadius: 4, fontSize: 11 }, labelStyle: { color: '#e6e8ea' } };

// Cumulative Ist vs. Soll over the window (x = window start → deadline); toggle: total line or A/B/C stacked areas.
export const CumChart = ({ card, allowSplit = true }) => {
  const [mode, setMode] = useState('total');
  const win = card.window || {};
  const s = card.series || {};
  const slices = win.slices || [];
  const n = slices.length;
  const long = n > 14;
  const today = win.today_idx;
  const data = slices.map((d, i) => {
    const visible = win.is_past || today === null || today === undefined || i <= today;
    const row = { day: long ? d.date : `${d.label} ${d.date}`, i, soll: card.target ? s.pace?.[i] : null };
    if (visible) {
      row.ist = s.cum?.[i];
      if (s.by_class) ['A', 'B', 'C'].forEach((c) => { row[c] = s.by_class[c]?.[i] ?? 0; });
    }
    return row;
  });
  const color = statusColor(card.status);
  const canSplit = allowSplit && card.has_split && !!s.by_class;
  const narrow = typeof window !== 'undefined' && window.innerWidth < 640;
  return (
    <div data-testid={`kpi-chart-${card.key}`}>
      {canSplit && (
        <div className="flex justify-end gap-1 mb-1">
          {[['total', 'Gesamt'], ['split', 'A / B / C']].map(([m, l]) => (
            <button key={m} onClick={() => setMode(m)} data-testid={`kpi-chart-${card.key}-mode-${m}`}
              className={`text-[9px] font-mono uppercase tracking-wider px-1.5 py-0.5 border rounded-sm transition-colors ${mode === m ? 'border-sky-500/50 bg-sky-500/10 text-sky-300' : 'border-border text-muted-foreground hover:text-foreground'}`}>{l}</button>
          ))}
        </div>
      )}
      <div className="h-[130px] w-full">
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={data} margin={{ top: 6, right: 8, bottom: 0, left: -22 }}>
            <XAxis dataKey="day" tick={{ fontSize: 8.5, fill: '#8a8f98' }} axisLine={false} tickLine={false}
              interval={long ? 6 : narrow ? 'preserveStartEnd' : 0} />
            <YAxis tick={{ fontSize: 10, fill: '#8a8f98' }} axisLine={false} tickLine={false} allowDecimals={false} />
            <Tooltip {...TT} />
            {card.target > 0 && <Line type="monotone" dataKey="soll" name="Soll jetzt" stroke="#38bdf8" strokeDasharray="4 4" strokeWidth={1.5} dot={false} connectNulls />}
            {mode === 'split' && canSplit
              ? ['A', 'B', 'C'].map((c) => (
                <Area key={c} type="monotone" dataKey={c} stackId="cls" name={`Klasse ${c}`} stroke={CLASS_COLORS[c]} fill={CLASS_COLORS[c]} fillOpacity={0.35} strokeWidth={1.5} dot={false} />
              ))
              : <Line type="monotone" dataKey="ist" name="Ist (kumuliert)" stroke={color} strokeWidth={2} dot={long ? false : { r: 2.5, fill: color }} />}
            {card.target > 0 && <ReferenceLine y={card.target} stroke="#6b7280" strokeOpacity={0.35} strokeWidth={1} />}
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
